<template>
  <div id="InvoiceReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Invoice Report</div>
          <div class="web-action-btn btn-groups text-right">
              <!-- Button for Clear Cache -->
              <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'invoiceReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
            <section class="bg-white data-table">
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'invoiceReport'" :position="'top'">
              </custom-pagination>
              <vue-good-table
                mode="remote"
                title="Invoice Report"
                ref="invoiceReportTbl"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-select-all="onSelectAll"
                @on-selected-rows-change="selectionChanged"
                :totalRows="totalRecords"
                :columns="userColumns"
                :rows="rows"
                :paginationOptions="{
                    enabled: false,
                    position: 'both',
                    perPage: perPage,
                    dropdownAllowAll: false,
                    setCurrentPage:listCurrentPage,
                    perPageDropdown:dropDownPerPage,
                }"
                :select-options="{
                    enabled: true,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                }"
                :search-options="{
                enabled: false,
                }"

                >
              </vue-good-table>
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import EventBus from "./../event-bus";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';

 let msgServer;

export default {
  name: "InvoiceReport",
  metaInfo() {
            return {title: "Invoice Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    batchProcess:0,
    batchNum:"",
    cantAccessPage:"",
    loading: false,
    action: '',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
                {
                    label: "Inv Number",
                    field: "invoice_number",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Inv Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                 {
                    label: "Source",
                    field: "inv_type",
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Source", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Invoice Date",
                    field: "invoice_date",
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Amount Invoiced",
                    field: "amount",
                    fpFieldType:"integer",
                    hidden:false,
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Amount Invoiced", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "PST Amount",
                    field: "pst_amount",
                    fpFieldType:"integer",
                    hidden:false,
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "PST Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable: false,
                },
                {
                    label: "GST Amount",
                    field: "gst_amount",
                    fpFieldType:"integer",
                    hidden:false,
                    filterable: false,
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Invoice Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable: false,
                },
                {
                    label: "Customer Number",
                    field: "customer",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Customer Name",
                    field: "cust_name",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Posting Period",
                    field: "post_period",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    type:'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Posting Period", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable: false,
                },
                {
                    label: "Posting Year",
                    field: "post_year",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    type:'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Posting Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable: false,
                },
                {
                    label: "Trans Sts",
                    field: "trans_sts",
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Trans Sts", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable: false,
                },
                // {
                //     label: "Customer Emails",
                //     field: "customer_emails",
                //     filterable: true,
                //     fpFieldType:"text",
                //     hidden:false,
                //     html: true,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Customers Emails", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                //         filterFn: this.onColumnFilter, //custom filter function that
                //         trigger: "enter" //only trigger on enter not on keyup
                //     },
                // },

                // {
                //     label: "Open Invoice Amount",
                //     field: "current_open_inv_amount",
                //     fpFieldType:"integer",
                //     hidden:false,
                //     filterable: true,
                //     type: 'number',
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Open Invoice Amount", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                //         filterFn: this.onColumnFilter, //custom filter function that
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: "Status",
                //     field: "inv_status",
                //     fpFieldType:"option",
                //     hidden:false,
                //     filterable: true,
                //     // type: 'number',
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "All", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         filterDropdownItems: ["Draft", "Billed","Sent"], // dropdown (with selected values) instead of text input
                //         filterFn: this.onColumnFilter, //custom filter function that
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: "Action By",
                //     field: "action_by",
                //     hidden:false,
                //     filterable: true,
                //     fpFieldType:"text",
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Action By", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                //         filterFn: this.onColumnFilter, //custom filter function that
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: "Sales Rep",
                    field: "sales_rep",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Sales Rep", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "AR Trans Number",
                    field: "ar_trans_no",
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "AR Trans Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable: false,
                },
                {
                    label: "Invoice Create Date",
                    field: "created_at",
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],


  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'invoice_list_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  created: function () {
    this.serverParams.stopRequest = true;
  },
  beforeDestroy() {
      // Make sure to close the connection with the events server
      // when the component is destroyed, or we'll have ghost connections!
      msgServer.close();
  },
  mounted: function(){
    var self = this;

    self.getPermissions();
  },
  
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.invoiceReportTbl.unselectAllInternal();
    },
    selectionChanged(param) {
        var self = this;
        self.serverParams.selectedAll = false;
        if(param.selectedRows.length == 100) {
          EventBus.$emit('clear-selection', false);
        } else {
          EventBus.$emit('clear-all-flags', false);
        }
        return;
    },


    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = self.$refs['invoiceReportTbl'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(self.$refs['invoiceReportTbl'].selectedRows[i].id)
      }


      $.ajax({
        url: process.env.ROOT_API + "/invoice-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: self.serverParams.columnFilters,
          sort: self.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {

            if ( self.action == "export" ||  self.action == "export_queue") {

              if ( data.code == "201" ) {
                  alert(data.message);
              } else {

                if ( self.action == "export" ) {

                    self.excel = data.content.web;
                    var save = document.createElement("a");
                    save.href = self.excel;
                    save.download = data.content.web;
                    save.target = "_blank";

                    document.body.appendChild(save);
                    save.click();
                    document.body.removeChild(save);

                } else {

                    self.batchProcess = 1;
                    self.batchNum = data.content;
                }

              }

              self.action = "list";
              self.loadList();
              return;
            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'invoice-report');
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/InvoiceReport.vue